<template>
   
    <div> 
        <div class="crumbs" hidden="true"  style="margin-left:10px;">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-calendar"></i> 产品管理
                </el-breadcrumb-item>
                <el-breadcrumb-item>渠道分类</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
          <el-card shadow="hover"  class="searchCard" >  
                <span class="label-span">
                    <label class="label">邮箱号</label> 
                    <el-input v-model.trim="query.username" placeholder="短信签名" class="handle-input mr10"></el-input> 
                </span>
                 <span class="label-span">
                    <label class="label">启用状态</label> 
                    <el-select v-model="query.status"  placeholder="产品状态" filterable  clearable class="handle-select mr10">
                        <el-option value="" label="全部"  />    
                        <el-option value="1" label="已启用"  /> 
                        <el-option value="0" label="已禁用"  />    
                    </el-select>
                </span> 
                <el-button type="success" icon="el-icon-search"  class="mr10"  @click="handleSearch">搜索</el-button>
                <el-button type="error" icon="el-icon-refresh" class="mr10" style="margin-right:25px;"  @click="refreshSearch">重置</el-button>
                <el-button  type="primary"  icon="el-icon-lx-roundadd" class="mr10"  @click="addBind" >新增邮箱</el-button> 
               
               
          </el-card>
          <el-card shadow="hover"  class="containCard" >  
            <el-table :data="tableData" border class="table"  ref="multipleTable" header-cell-class-name="table-header"  @selection-change="handleSelectionChange"  >
                <!--<el-table-column type="selection" width="35" align="center"></el-table-column>--> 
                <el-table-column prop="name" min-width="100" align="center" label="发件人"></el-table-column>     
                <el-table-column prop="username" min-width="150" align="center" label="邮箱账号">
                    <template slot-scope="scope" >   
                        <span style="font-size:12px">{{scope.row.username}} </span>
                    </template>         
                </el-table-column>     
                <el-table-column prop="password" min-width="100" align="center" label="邮箱密码">
                    <template slot-scope="scope" >   
                        <span style="font-size:12px">{{scope.row.password}} </span>
                    </template> 
                </el-table-column>     
                <el-table-column prop="token" min-width="130" align="center" label="授权码">
                    <template slot-scope="scope" >   
                        <span style="font-size:12px">{{scope.row.token}} </span>
                    </template>     
                </el-table-column>     
                <el-table-column prop="host" min-width="100" align="center" label="请求服务器"></el-table-column>      
                <el-table-column prop="status" width="80" align="center" label="启用状态">
                      <template slot-scope="scope" >   
                        <el-tooltip :content="scope.row.status=='1'?'已启用':'已禁用'" placement="top">
                            <el-switch @change="handleStatus(scope.$index, scope.row)"
                                v-model="scope.row.status"
                                active-color=""
                                inactive-color=""
                                active-value="1"
                                inactive-value="0">
                            </el-switch>
                        </el-tooltip>
                    </template> 
                </el-table-column>  
                <el-table-column prop="createTime" width="165" align="center"  label="创建时间"> </el-table-column>  
                <el-table-column label="操作" width="140" align="center"  fixed="right">
                    <template slot-scope="scope"> 
                        <span class='tableOperBtn' @click="handleEdit(scope.$index, scope.row)" ><i class='el-icon-edit'></i> 编辑</span>
                        <span class='tableOperBtn' @click="handDelete(scope.$index, scope.row)" ><i class='el-icon-delete'></i> 删除</span>
                    </template>
                </el-table-column>
                  
            </el-table>
            <div class="pagination">
                <el-pagination 
                   background
                    layout="total,  sizes,prev, pager, next,jumper"
                    :page-sizes="[10, 20, 50]"
                    :current-page="query.pageIndex"
                    :page-size="query.pageSize"
                    :total="pageTotal"
                    @size-change="handleSizeChange"
                    @current-change="handlePageChange" 
                ></el-pagination>
            </div>
          </el-card> 
        <!-- 新建自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="新增配置" :visible.sync="addVisible" :modal-append-to-body='false' top="80px" width="530px">
            <el-form ref="form1" :model="form1" label-width="90px" @submit.native.prevent="saveForm"> 
                <el-form-item label="发件人">
                    <el-input v-model.trim="form1.name"  placeholder="发件人" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="邮箱账号">
                    <el-input v-model.trim="form1.username"  placeholder="邮箱账号" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="邮箱密码">
                    <el-input v-model.trim="form1.password"  placeholder="邮箱密码" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="授权码">
                    <el-input v-model.trim="form1.token"  placeholder="授权码" style="width:360px;"></el-input>
                </el-form-item> 
                 <el-form-item label="请求服务器">
                    <el-input v-model.trim="form1.host"  placeholder="请求服务器" style="width:360px;"></el-input>
                </el-form-item>   
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveForm">{{ isSubmitting ? '提交中...' : '提 交' }}</el-button>
            </span>
        </el-dialog>
         
  

        <!-- 编辑自主渠道弹出框 --> 
        <el-dialog :close-on-click-modal="false" title="编辑配置" :visible.sync="editVisible" :modal-append-to-body='false' top="50px" width="530px">
            <el-form ref="form" :model="form3" label-width="90px">
                <el-form-item label="发件人">
                    <el-input v-model.trim="form3.name"  placeholder="发件人" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="邮箱账号">
                    <el-input v-model.trim="form3.username"  placeholder="邮箱账号" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="邮箱密码">
                    <el-input v-model.trim="form3.password"  placeholder="邮箱密码" style="width:360px;"></el-input>
                </el-form-item> 
                <el-form-item label="授权码">
                    <el-input v-model.trim="form3.token"  placeholder="授权码" style="width:360px;"></el-input>
                </el-form-item> 
                 <el-form-item label="请求服务器">
                    <el-input v-model.trim="form3.host"  placeholder="请求服务器" style="width:360px;"></el-input>
                </el-form-item>  
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="editVisible = false">取 消</el-button>
                <el-button type="primary" @click="saveEdit">确 定</el-button>
            </span>
        </el-dialog>
          
    </div>
</template>

<script>
import {fetchData,saveForm,handDelete,changeForm,changeStatus} from '../../../api/comEmail';
export default {

    data() {
        return {  
            isSubmitting: false, // 是否正在提交
            Timeout:'', 
            activeNames:1,
            select:{ option:'',  },
            sendSms:{
                code:'', 
                content:'发送验证码',
                type:'danger',
                disabled:false,
                color:'color:#fff',
             },
            
            query: { 
                pageIndex: 1,
                pageSize: 10,  
            },
            tableData: [],
            tableData2: [],
            multipleSelection: [],
            delList: [],
            editVisible: false,
            editPlusVisible: false,
            addVisible: false,
            addPlusVisible:false,
            detailVisible:false, 
            dirVisible:false,
            row:{},
            pageTotal: 0,
            form: {  
                ids:'',
                names:'',
            },
            form1: {
                smsFrom:'1', 
                smsType:'1',  
            },
            form2: {   },
            form3: {   },
            form4: {   },
            idx: -1,
            id: -1
        };
    },
    created() {
         
    },
    //页面加载方法
    mounted: function () { 
        //查询列表
        this.getData();  
    },

    methods: {  
        // 触发搜索按钮 
        handleSearch() {
            this.$set(this.query, 'pageIndex', 1);
            this.getData();
        },

        //重置按钮
        refreshSearch(){ 
            this.$set(this.query, 'username');  
            this.$set(this.query, 'status');     
            this.handleSearch();
        }, 
    

        //触发刷新按钮
        refresh(){
            history.go(0);
            
        }, 

        //查询
        getData(){  
            fetchData(this.query).then(res => {  
                if(res.code=='200'){ 
                    this.tableData = res.data.list;
                    this.pageTotal = res.data.pageTotal ;  
                }else{
                    this.tableData = []; 
                    this.pageTotal = 0;
                } 
                
            });
        },
          

        // 新增渠道
        addBind() {
            this.addVisible = true; 
        },
        //保存新增
        saveForm() {   
            if (this.isSubmitting) return;
            this.isSubmitting = true; // 禁用按钮
            if( !this.form1.name ){
                this.isSubmitting = false;
                this.$message.error("请填写发件人");
                return;
            }  
            if( !this.form1.username ){
                this.isSubmitting = false;
                this.$message.error("请填写邮箱账号");
                return;
            } 
            if( !this.form1.password ){
                this.isSubmitting = false;
                this.$message.error("请填写邮箱密码");
                return;
            } 
            if( !this.form1.token ){
                this.isSubmitting = false;
                this.$message.error("请填写授权码");
                return;
            } 
            if( !this.form1.host ){
                this.isSubmitting = false;
                this.$message.error("请填写请求服务器");
                return;
            } 
            this.addVisible = false;  
            saveForm(this.form1).then(res => {
                this.isSubmitting = false; 
                if(res.code=='200'){ 
                    this.$message.success(res.message); 
                    this.refreshSearch();
                }else{
                    this.addVisible = true;  
                    this.$message.error(res.message); 
                } 
            });
        },

        

        // 编辑操作
        handleEdit(index, row) {      
            this.editVisible = true;
            this.form3 = row; 
        },
 
        
        // 保存更改
        saveEdit() {   
            if( !this.form3.name ){ 
                this.$message.error("请填写发件人");
                return;
            }  
            if( !this.form3.username ){ 
                this.$message.error("请填写邮箱账号");
                return;
            } 
            if( !this.form3.password ){ 
                this.$message.error("请填写邮箱密码");
                return;
            } 
            if( !this.form3.token ){ 
                this.$message.error("请填写授权码");
                return;
            } 
            if( !this.form3.host ){ 
                this.$message.error("请填写请求服务器");
                return;
            } 
            changeForm(this.form3).then(res => {
                if(res.code=='200'){
                    this.editVisible = false; 
                    this.$message.success(res.message); 
                    this.getData();
                }else{
                    this.$message.error(res.message); 
                }
            });
        },
        // q启用、禁用--改变状态
        handleStatus(index, row) {  
            var tips ;
            var content;
            if(row.status=='0'){ 
                tips = "禁用";
                content = "确定禁用吗？";
            }else{ 
                tips = "启用";
                content = "确定启用吗？"; 
            } 
            changeStatus(row).then(res => {
                if(res.code=='200'){ 
                    this.$message.success(tips+'成功'); 
                    this.getData();
                }else{ 
                    this.$message.error(tips+'失败');
                } 
            });
             
           
        },
 
        
        //详情
        handleDetail(index, row){
            this.form2 = row; 
            if(row.channelType=='1'){
                this.detailVisible = true; 
            }
            
        },
        // 删除
        handDelete(index, row) {  
            this.form.id=row.id; 
            this.form.mid = this.mid;
            this.form.stationId = this.stationId; 
            // 二次确认删除
            this.$confirm('确认删除吗？', '提示', {
                type: 'warning'
            }).then(() => {
                handDelete(this.form).then(res => {
                    if(res.code=='200'){ 
                        this.$message.success('删除成功'); 
                        this.$set(this.query, 'pageIndex', 1); 
                        this.getData();
                    }else{
                        this.$message.error("删除失败"); 
                    } 
                });
            }) 
        },
        // 分页导航
        handlePageChange(val) { 
            this.$set(this.query, 'pageIndex', val);
            this.getData();
        },
        //分页数量更改导航
        handleSizeChange(val){
            this.$set(this.query, 'pageSize', val);
            this.getData();
        }
    }
};
</script>

<style scoped>
.label{
    background: #eee;
    font-size: 14px;
    height: 32px;
    display: inline-block;
    line-height: 33px;
    width:100px;
    text-align:center;
    color: #555;
  }
  .label-span{
      display: inline-block;
      height: 45px;
  }
.handle-box {
    width:100%;
    margin-bottom: 20px;
    overflow-x:auto;
}

.handle-select {
    width: 100px;
    display: inline-block;
}

.handle-input {
    width: 150px;
    display: inline-block;
}
.handle-del {
    float:right; 
}
.table {
    width: 100%;
    font-size: 14px;
}
.red {
    color: #ff0000;
}
.mr10 {
    margin-right: 10px;
    margin-left:0;
}
.mr15 {
    margin-right: 15px;
}
.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}
</style>
